import { useBuyerOrderList } from "../../../../hooks/api/v2/order/useBuyerOrderList";
import { RequestedOrdersList } from "./RequestedOrdersList";

export const BuyerActionRequiredOrderList = ({
  selectedOrderId,
}: {
  selectedOrderId: number | null;
}) => {
  const query = useBuyerOrderList({
    limit: 20,
    query: [
      {
        type: "requiredAction",
        modifier: "EQUALS",
        value: true,
      },
      {
        type: "cancelledAt",
        modifier: "IS_NULL",
      },
      {
        type: "deniedAt",
        modifier: "IS_NULL",
      },
    ],
  });
  return (
    <RequestedOrdersList query={query} selectedOrderId={selectedOrderId} />
  );
};
